import { useAccountsDataContext } from '#client/AccountsDataContext';
import useApplicationStatusContext from '#client/hooks/useApplicationStatusContext';
import { useLogError } from '#client/hooks/useLogError';

export default function useBankingAccounts() {
  const { loading: appStatusLoading } = useApplicationStatusContext();
  const {
    errors,
    error,
    data,
    loading: isFetchingBankingAccounts,
    refetch
  } = useAccountsDataContext();

  useLogError(errors, error);

  const { id } = data?.bankingAccounts?.[0] || {};

  return {
    refetch,
    loading: isFetchingBankingAccounts || appStatusLoading,
    id
  };
}
